import * as config from './config.js';
// import * as EmailValidator from 'email-validator';
// var emailValidator = require("email-validator")

var text = config.text;
text.bookingSuccess = '申込みが完了致しました。';

// show map on click buttons
$('body').on('click', '.btn-show-map', function (e) {
    e.preventDefault();
    var place = $(this).attr('data-place');
    var address = $(this).attr('data-address');
    $('#modal-map').find('.modal-title').html("開催場所");
    $('#modal-map').find('.modal-footer').find('.place').html(place);
    $('#modal-map').find('.modal-footer').find('.address').html(address);
    config.showLoading($('#modal-map').find('.modal-footer'));
    $('#modal-map').modal('show');
});
$('#modal-map').on('shown.bs.modal', function () {
    initializeMap('map-in-modal', $('#modal-map').find('.modal-footer').find('.place').html(), $('#modal-map').find('.modal-footer').find('.address').html());
    config.hideLoading();
});
$('#modal-map').on('hidden.bs.modal', function () {
    $('#map-in-modal').html('');
});

function initializeMap(mapDivId, place, address) {
    GMaps.geocode({
        address: address,
        callback: function (results, status) {
            if (status == 'OK') {
                $('#map').show();
                var latlng = results[0].geometry.location;
                $('#modal-map').find('.modal-footer').find('a').attr('href', 'http://www.google.com/maps/place/' + latlng.lat() + ',' + latlng.lng());

                var map = new GMaps({
                    div: '#' + mapDivId,
                    zoom: 14,
                    lat: latlng.lat(),
                    lng: latlng.lng()
                });

                //map.fitBounds(results[0].geometry.viewport);
                map.setCenter(latlng.lat(), latlng.lng());
                map.addMarker({
                    lat: latlng.lat(),
                    lng: latlng.lng(),
                    title: place,
                    infoWindow: {
                        content: '<p>' + place + '</p><p>' + address + '</p>'
                    }
                });
            } else {
                $('#map').hide();
                $('#map-in-modal').html('地図が表示されません。');
            }
        }
    });
}
// on click choose event private
$('body').on('click', '.btn-choose.private-event', function () {
    config.showModal(config.modalInfo, config.modalTitle, 'お手数ですが、お申込みになりたいイベントページから再度お申込みボタンを押してください。');
});
// on click floating banner
$('body').on('click', '.floating-banner', function (e) {
    e.preventDefault();
    console.log($('.event-date-list-top a.btn-choose').length)
    if ($('.event-date-list-top a.btn-choose').length == 1) {
        console.log($('.event-date-list-top a.btn-choose').attr('href'))
        window.location.href = $('.event-date-list-top a.btn-choose').attr('href');
    } else {
        $('html, body').animate({ scrollTop: 0 }, '2000');
    }
});
// BOOKING
if ($('#booking').length > 0) {
    var bookingData;
    var followerIndexInput = $('input[name="follower_index"]');

    // on change ticket 
    $('body').on('change', '.select-event-ticket-wrap select.select-event-ticket', function () {
        var selectTicket = $(this);
        var inputTicket = selectTicket.parents('.select-event-ticket-wrap').find('.ticket-id');
        var newTicketId = selectTicket.val();
        var oldTicketId = inputTicket.val();
        changeTicket(selectTicket, oldTicketId, newTicketId);
    });
    // on add follower
    $('body').on('click', '.btn-add-follower', function (e) {
        e.preventDefault();
        addFollower();
    });
    function addFollower() {
        var eventId = $('#event_id').val();
        var eventDateId = $('.select-event-date').selectpicker('val');
        // get index of the last followwer
        var theLastFollowerItem = $('.follower-container').find('.follower-item:last');
        var followerIndex = 0;
        if ($('.follower-container').find('.follower-item').length > 0) {
            // if ($('.follower-container').find('.follower-item').length + 2 >= parseInt($('.ticket-data').find('.total-remain').html())) {
            //     $('.btn-add-follower').prop('disabled', true);
            // }
            followerIndex = theLastFollowerItem.attr('data-index');
        }
        followerIndex++;
        $.ajax({
            url: '/add-follower',
            type: 'POST',
            dataType: 'json',
            data: {
                event_id: eventId,
                event_date_id: eventDateId,
                followerIndex: followerIndex
            },
            beforeSend: function (er) {
                config.showLoading($('.follower-container'));
                getDefaultTicket();
            },
            success: function (res) {
                config.hideLoading();
                if (res.status == 'error') {
                    config.showModal(config.modalInfo, config.modalTitle, text.error);
                } else {
                    $('.follower-container').append(res.html).removeClass('d-none');
                    $('select.select-event-ticket').selectpicker();
                    $('.form-element').selectpicker();
                    followerIndexInput.val(followerIndexInput.val() + followerIndex + '.');
                    // set ticket 
                    setDefaultTicket(true);
                    // update ticket status
                    updateTicketStatus();
                }
            },
            error: function () {
                console.log('エラー');
            }
        });
    }
    // on delete follower
    $('body').on('click', '.btn-delete-follower', function (e) {
        e.preventDefault();
        var followerItem = $(this).parent().parent('.follower-item');
        followerItem.attr('data-confirm-delete', '1');
        config.getConfirmDelete('delete-follower');
    });
    $('body').on('click', '#modal-action .btn[data-choose="ok"][data-type="delete-follower"]', function (e) {
        e.preventDefault();
        var followerItem = $('.follower-item[data-confirm-delete]');
        removeFollowerTicket(followerItem);
    });
    // valid event booking
    function validEventBooking() {
        $('.ticket-id').each(function () {
            if (parseInt($(this).val()) == 0) {
                config.appendInvalidDiv($(this).parent(), text.invalidRequired);
            } else {
                config.removeInvalidDiv($(this).parent());
            }
        });
        // last_name
        $('.last-name').each(function () {
            if ($(this).val().trim().length == 0) {
                config.appendInvalidDiv($(this).parent(), text.invalidRequired);
            } else {
                config.removeInvalidDiv($(this).parent());
            }
        });
        // first_name
        $('.first-name').each(function () {
            if ($(this).val().trim().length == 0) {
                config.appendInvalidDiv($(this).parent(), text.invalidRequired);
            } else {
                config.removeInvalidDiv($(this).parent());
            }
        });
        // last_name Kana
        $('.last-name-kana').each(function () {
            if ($(this).val().trim().length == 0) {
                config.appendInvalidDiv($(this).parent(), text.invalidRequired);
            } else {
                if (!config.checkKana($(this).val().trim())) {
                    config.appendInvalidDiv($(this).parent(), text.invalidKana);
                } else {
                    config.removeInvalidDiv($(this).parent());
                }
            }
        });
        // first_name Kana
        $('.first-name-kana').each(function () {
            if ($(this).val().trim().length == 0) {
                config.appendInvalidDiv($(this).parent(), text.invalidRequired);
            } else {
                if (!config.checkKana($(this).val().trim())) {
                    config.appendInvalidDiv($(this).parent(), text.invalidKana);
                } else {
                    config.removeInvalidDiv($(this).parent());
                }
            }
        });
        // email
        $('.email').each(function () {
            if ($(this).val().trim().length == 0) {
                config.appendInvalidDiv($(this).parent(), text.invalidRequired);
            } else if (!config.emailPattern.test($(this).val().trim())) {
                config.appendInvalidDiv($(this).parent(), text.invalidEmail);
                // } else if (!EmailValidator.validate($(this).val().trim())) {
            } else if (!config.ValidateEmail($(this).val().toLowerCase().trim())) {
                config.appendInvalidDiv($(this).parent(), text.invalidEmail);
            } else {
                config.removeInvalidDiv($(this).parent());
            }
        });
        // form element
        $('.form-element.required').each(function () {
            var nameInput = $(this).attr('name');
            if ($(this).prop('tagName').toLowerCase() == 'input') {
                if ($(this).attr('type') == 'text' && $(this).val().trim().length == 0) {
                    config.appendInvalidDiv($(this).parent(), text.invalidRequired);
                } else if ($(this).attr('type') == 'radio') {
                    if ($('input[name="' + nameInput + '"]:checked').length == 0) {
                        config.appendInvalidDiv($(this).parent(), text.invalidRequired);
                    } else {
                        config.removeInvalidDiv($(this).parent().parent());
                    }
                } else if ($(this).attr('type') == 'checkbox') {
                    if ($(this).parent().find('.form-element.required:checked').length == 0) {
                        config.appendInvalidDiv($(this).parent(), text.invalidRequired);
                    } else {
                        config.removeInvalidDiv($(this).parent());
                    }
                } else {
                    config.removeInvalidDiv($(this).parent());
                }
            } else if ($(this).prop('tagName').toLowerCase() == 'textarea') {
                if ($(this).val().trim().length == 0) {
                    config.appendInvalidDiv($(this).parent(), text.invalidRequired);
                } else {
                    config.removeInvalidDiv($(this).parent());
                }
            } else if ($(this).prop('tagName').toLowerCase() == 'select') {
                if ($(this).val().trim().length == 0) {
                    config.appendInvalidDiv($(this).parent().parent(), text.invalidRequired);
                } else {
                    config.removeInvalidDiv($(this).parent().parent());
                }
            }
        });

        if ($('#booking').find('.invalid-message').length == 0) {
            return true;
        }
        return false;
    }
    // remove invalid message on click radio or checkbox
    $('body').on('click', '.form-element.required[type="radio"], .form-element.required[type="checkbox"]', function (e) {
        config.removeInvalidDiv($(this).parent().parent());
    });
    $('body').on('click', '#agree_term', function () {
        if ($('#agree_term').is(":checked")) {
            config.removeInvalidDiv($('#agree_term').parent().parent());
        }
    });
    // on click confirm booking
    $('body').on('click', '.btn-confirm-submit', function (e) {
        e.preventDefault();
        if ($('#agree_term').is(":not(:checked)")) {
            config.appendInvalidDiv($('#agree_term').parent().parent(), 'Eventlink利用規約とイベントリンク参加規約に同意していません。');
        } else {
            config.removeInvalidDiv($('#agree_term').parent().parent());
        }
        var eventId = $('#event_id').val();
        var eventDateId = $('.select-event-date').selectpicker('val');
        if (validEventBooking() == false) {
            var theFirstInvalidMessage = $('#booking').find('.invalid-message:first');
            config.scrollTo(theFirstInvalidMessage);
        } else {
            var frmData = $('#form-booking').serializeArray();
            bookingData = config.convertJsonData(frmData);
            disableBookingForm();
        }
        $('.error-exist').addClass('d-none');
    });
    function disableBookingForm() {
        $('#form-booking').find('fieldset').prop('disabled', true);
        $('.btn-add-follower, .btn-confirm-submit').addClass('d-none');
        // $('.btn-add-follower, .btn-confirm-submit').prop('disabled', true);
        $('.btn-confirm-back, .btn-booking-submit, .alert-confirm').removeClass('d-none');
        $('select.select-event-ticket').prop('disabled', true).selectpicker('refresh');
        $('select.form-element').prop('disabled', true).selectpicker('refresh');
        $('.btn-delete-follower').prop('disabled', true);
    }
    function enableBookingForm() {
        $('#form-booking').find('fieldset').prop('disabled', false);
        $('.btn-add-follower, .btn-confirm-submit').removeClass('d-none');
        // $('.btn-add-follower, .btn-confirm-submit').prop('disabled', false);
        $('.btn-confirm-back, .btn-booking-submit, .alert-confirm').addClass('d-none');
        $('select.select-event-ticket').prop('disabled', false).selectpicker('refresh');;
        $('select.form-element').prop('disabled', false).selectpicker('refresh');;
        $('.error-exist').addClass('d-none');
        $('.btn-delete-follower').prop('disabled', false);
    }
    // back to input data
    $('body').on('click', '.btn-confirm-back', function (e) {
        e.preventDefault();
        enableBookingForm();
    });
    // submit booking
    $('body').on('click', '.btn-booking-submit', function (e) {
        e.preventDefault();
        $.ajax({
            url: '/submit-booking',
            type: 'POST',
            dataType: 'json',
            data: bookingData,
            beforeSend: function () {
                config.showLoading($('body'));
                $('.btn-booking-submit').prop('disabled', true);
                $('.error-exist').addClass('d-none');
            },
            success: function (res) {
                if (res.status == 'error') {
                    config.hideLoading();
                    $('.btn-booking-submit').prop('disabled', false);
                    var errorExist = false;
                    $.each(res.messages, function (index, item) {
                        if (index == 'attendee_exist') {
                            errorExist = true;
                        }
                        var elementInput = $('[name="' + index + '"]');
                        config.appendInvalidDiv(elementInput.parent(), item);
                    });
                    enableBookingForm();
                    if ($('#booking').find('.invalid-message').length > 0) {
                        var theFirstInvalidMessage = $('#booking').find('.invalid-message:first');
                        config.scrollTo(theFirstInvalidMessage);
                    }
                    if (errorExist == true) {
                        $('.error-exist').removeClass('d-none');
                    }
                } else if (res.status == 'success') {
                    location.reload();
                }
            },
            error: function () {
                console.log('エラー');
            }
        });
    });
    if ($('.booking-success').length > 0) {
        $('.copyright').addClass('fixed-bottom');
    }
}
function getDefaultTicket() {
    $('.ticket-status').each(function (index, item) {
        if (parseInt($(this).find('.remain').html()) > parseInt($(this).find('.selecting').html())) {
            $(this).attr('data-ticket-default', 1);
            return false;
        } else {
            $(this).attr('data-ticket-default', 0);
        }
    });
}
function setDefaultTicket(isFollower) {
    var defaultTicketId = $('.ticket-status[data-ticket-default="1"]').attr('data-ticket-id');
    var newLastFollowerItem;
    if (isFollower) {
        newLastFollowerItem = $('.follower-container').find('.follower-item:last');
    } else {
        newLastFollowerItem = $('.ticket-container').find('.select-event-ticket-wrap');
    }
    var theLastSelect = newLastFollowerItem.find('select.select-event-ticket');
    theLastSelect.selectpicker('val', defaultTicketId);
    theLastSelect.parents('.select-event-ticket-wrap').find('.ticket-id').val(defaultTicketId);
}
function updateTicketStatus() {
    $('.ticket-status').find('.selecting').html(0)
    var totalSelecting = 0;
    $('select.select-event-ticket').each(function (index, item) {
        var selectPicker = $(this);
        var selectedTicketId = selectPicker.val();
        var wrapRemainStatus = $('.ticket-status[data-ticket-id="' + selectedTicketId + '"]').find('.remain');
        var remainStatus = parseInt(wrapRemainStatus.html());
        var wrapSelectingStatus = $('.ticket-status[data-ticket-id="' + selectedTicketId + '"]').find('.selecting');
        var plusSelectingStatus = parseInt(wrapSelectingStatus.html()) + 1;
        if (selectedTicketId != "") {
            if (plusSelectingStatus <= remainStatus) {
                wrapSelectingStatus.html(plusSelectingStatus)
                totalSelecting++;
            }
        }
        // on finish each loop
        if (index == $('select.select-event-ticket').length - 1) {
            $('.ticket-data').find('.total-selecting').html(totalSelecting);
            console.log(parseInt($('.ticket-data .total-remain').html()))
            if (parseInt($('.ticket-data .total-selecting').html()) >= parseInt($('.ticket-data .total-remain').html())) {
                $('.btn-add-follower').prop('disabled', true);
            }
        }
    });
}
function removeFollowerTicket(followerItem) {
    followerIndexInput.val(followerIndexInput.val().replace(followerItem.attr('data-index') + '.', ''));
    followerItem.remove();
    $('.btn-add-follower').prop('disabled', false);
    updateTicketStatus()
}
function changeTicket(selectTicket, oldTicketId, newTicketId) {
    var newTicketWrap = $('.ticket-status[data-ticket-id="' + newTicketId + '"]');
    var wrapNewRemainStatus = newTicketWrap.find('.remain');
    var newRemainStatus = parseInt(wrapNewRemainStatus.html());
    var wrapNewSelectingStatus = newTicketWrap.find('.selecting');
    var newSelectingStatus = parseInt(wrapNewSelectingStatus.html());
    if (newRemainStatus <= 0 || newRemainStatus <= newSelectingStatus) {
        config.showModal(config.modalInfo, config.modalTitle, '<p>選択したチケットは定員に達しています。<br/>別のチケットを選んでください。</p>');
        selectTicket.selectpicker('val', oldTicketId);
        selectTicket.parents('.select-event-ticket-wrap').find('.ticket-id').val(oldTicketId);
    } else {
        selectTicket.parents('.select-event-ticket-wrap').find('.ticket-id').val(newTicketId);
        updateTicketStatus();
    }
}

$(function () {
    // if ($('#event').hasClass('from_web')) {
    //     var href = new URL($(location).attr('href'));
    //     if (href.toString().indexOf('web')==-1) {
    //         href.searchParams.set('web', 1);
    //         window.location.replaceState(href.toString())
    //     }
    // }

    if ($('#booking').length > 0) {
        setDefaultTicket(false);
    }

    if ($('.event-location').length > 0) {
        var place = $('.event-location').attr('data-place');
        var address = $('.event-location').attr('data-address');
        $('#map').hide();
        google.maps.event.addDomListener(window, "load", initializeMap('map', place, address));
    }

    config.breakStr();

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if ($('.floating-banner').length > 0) {
            $('body').css({
                'padding-bottom': ($('.floating-banner').height() + 30) + 'px'
            });
        }
    }

});